module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "contact-me"
  }, [_c('bacon', {
    attrs: {
      "title": "Let's make some Art!"
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('a', {
    staticClass: "button",
    attrs: {
      "href": "/contact"
    }
  }, [_vm._v("Contact Me!")])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "two-line-heading"
  }, [_vm._v("I am based in Chicago,\n    "), _c('span', [_vm._v("But I work with clients from all over world.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dac47ba6","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/contact-me.vue
// module id = 161
// module chunks = 0